import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

import { translate, TranslationTokens } from './translate.util';

@Pipe({
  name: 'idealsTranslate',
  // eslint-disable-next-line @angular-eslint/no-pipe-impure
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  readonly #changeDetectorRef = inject(ChangeDetectorRef);
  readonly #translateService = inject(TranslateService);

  constructor() {
    // Marks the host view dirty on language change so OnPush components re-render this pipe's translation.
    this.#translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.#changeDetectorRef.markForCheck());
  }

  transform(value: TranslationTokens | undefined, defaultValue: string = ''): string {
    return value ? translate(this.#translateService, value) : defaultValue;
  }
}
